import I18n from 'i18n-js';
import React from 'react';
import { Location } from 'history';
import { DEFAULT_CONDITION, MARKETPLACE_PATH } from '../shared/constants';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import EMPTY_STATE_IMAGE from '../../../images/icons/empty-states/no-listings@2x.png';
import FollowButtonContainer from './feed/follow_button_container';
import { CoreShopMarketplace } from '../../schemas/rql';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';

interface IProps {
  location: Location;
  shop: CoreShopMarketplace.Shop;
}

function NoSearchResults(props: { query: object }) {
  return (
    <div>
      <img
        src={EMPTY_STATE_IMAGE}
        className="mlr-auto mobile-width-70"
        alt={I18n.t('discovery.emptyShop.noListings')}
      />
      <h2 className="cms-h2">
        {I18n.t('discovery.emptyShop.nothingInShopMatchingSearch')}
      </h2>
      <CoreLink
        to={{
          pathname: `/${MARKETPLACE_PATH}`,
          query: props.query,
        }}
        className="icon-r-arrow-right weight-bold"
      >
        {I18n.t('discovery.emptyShop.expandSearchToAllShops')}
      </CoreLink>
    </div>
  );
}

function ShopHasNoListings() {
  return (
    <div>
      <img
        src={EMPTY_STATE_IMAGE}
        className="mlr-auto mobile-width-70"
        alt={I18n.t('discovery.emptyShop.noListings')}
      />
      <h2 className="cms-h2">
        {I18n.t('discovery.emptyShop.shopHasNoListings')}
      </h2>
      <a href="/shops" className="button button--primary">
        {I18n.t('discovery.emptyShop.seeTopShops')}
      </a>
    </div>
  );
}

function VacationMode(props: { shopID: string, shopName: string }) {
  return (
    <div data-vacation-message className="site-wrapper site-wrapper--cms">
      <div className="bg-white bd-1 bd-primary standard-shadow mb-4 align-center scaling-padding-4">
        <h3 className="cms-h1 mt-0">
          {I18n.t('discovery.emptyShop.vacation.title', { name: props.shopName })}
        </h3>
        <h4 className="cms-h3">
          {I18n.t('discovery.emptyShop.vacation.subtitle')}
        </h4>
        <p>
          {I18n.t('discovery.emptyShop.vacation.action')}
        </p>
        <FollowButtonContainer
          followParams={{
            shop_id: props.shopID,
          }}
        />
      </div>
    </div>
  );
}

function ShopOwnerShop() {
  return (
    <div>
      <h2 className="cms-h2">
        {I18n.t('discovery.emptyShop.yourShopIsEmpty')}
      </h2>
      <a
        href="/sell"
        className="button button--primary"
      >
        {I18n.t('discovery.emptyShop.listAnItem')}
      </a>
    </div>
  );
}

export class EmptyShop extends React.Component<IProps & IUserContext, null> {
  isFiltering() {
    const { condition = DEFAULT_CONDITION, ...otherFilters } = this.props.location.query;
    return condition !== DEFAULT_CONDITION || Object.keys(otherFilters).length > 0;
  }

  isShopOwner() {
    return `${this.props.user.id}` === this.props.shop.userId;
  }

  renderEmptyState() {
    if (this.props.shop.onVacation) {
      return <VacationMode
        shopID={this.props.shop.id}
        shopName={this.props.shop.name}
      />;
    }

    if (this.isFiltering()) {
      return <NoSearchResults query={this.props.location.query} />;
    }

    if (this.isShopOwner()) {
      return <ShopOwnerShop />;
    }

    return <ShopHasNoListings />;
  }

  render() {
    return (
      <section className="align-center scaling-padding-4">
        {this.renderEmptyState()}
      </section>
    );
  }
}

export default withUserContext<IProps>(EmptyShop);
